import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import {
  IServicePermissions,
  RbacRoleType,
} from '../../../../../../model/rbac';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import './index.scss';
import menuDown from '../../../../../../assets/svg/menu-down.svg';
import perFour from '../../../../../../assets/svg/per-four.svg';
import accessOneTrue from '../../../../../../assets/svg/access-one-true.svg';
import accessOneFalse from '../../../../../../assets/svg/access-one-false.svg';
import accessTwoTrue from '../../../../../../assets/svg/access-two-true.svg';
import accessTwoFalse from '../../../../../../assets/svg/access-two-false.svg';
import classNames from 'classnames';
import getFormatMessage from '../../../../../../locales/get-format-message';
import { ISystemMenuItem } from '../../../../../../model/system/menu';

interface IProps {
  readonly data: IServicePermissions;
  readonly checkedKeys: string[];
  readonly setCheckedKeys: (value: string[]) => void;
  readonly disabled: boolean;
  readonly type: string | null;
  readonly menus: ISystemMenuItem[];
}

export const AccessRights = (props: IProps) => {
  const { data, checkedKeys, setCheckedKeys, disabled, menus } = props;
  const [selectedKey, setSelectedKey] = useState<number | null>(null); // 服务权限选中项
  const [hiddenKeys, setHiddenKeys] = useState<number[]>([]); // 默认展开项

  useEffect(() => {
    const serviceData =
      data.objectGroup.filter((item) => item.objectGroupName === '服务权限') ||
      [];
    const serviceLeftOptions = getDataFromGroup(serviceData[0]?.objectGroupId);
    setSelectedKey(serviceLeftOptions[0]?.value);
  }, []);

  const getDataFromGroup = (parentId: number) => {
    const groupChildren = data.objectGroup
      .filter((item) => item.parentId === parentId)
      .map((group) => ({
        label: group.objectGroupName,
        value: group.objectGroupId,
        sortNum: 0, // 服务权限一级目录排序
      }));

    return [...groupChildren];
  };
  const getDataFromObjects = (parentId: number) => {
    const objectChildren = data.objects
      .filter((object) => object.objectGroupId === parentId)
      .map((object) => ({
        label: object.objectName,
        value: object.objectKey,
      }));

    return [...objectChildren];
  };

  const onChange = (checkedValue: CheckboxValueType[], options: string[]) => {
    const newValue = Object.assign([], checkedKeys);
    options.map((item) => {
      if (checkedValue.indexOf(item) !== -1 && newValue.indexOf(item) === -1) {
        newValue.push(item);
      }
      if (checkedValue.indexOf(item) === -1 && newValue.indexOf(item) !== -1) {
        newValue.splice(newValue.indexOf(item), 1);
      }
      return newValue;
    });
    setCheckedKeys(newValue);
  };

  const onObjectChange = (e: CheckboxChangeEvent, clickValue: string) => {
    const newValue = Object.assign([], checkedKeys);
    if (e.target.checked) {
      if (newValue.indexOf(clickValue) === -1) {
        newValue.push(clickValue);
      }
    } else {
      if (newValue.indexOf(clickValue) !== -1) {
        newValue.splice(newValue.indexOf(clickValue), 1);
      }
    }
    setCheckedKeys(newValue);
  };

  const getAllObjectKeys = (id: number) => {
    let objectKeys: string[] = [];

    // 获取当前id对应的所有group子项
    const childrenGroup =
      data.objectGroup.filter((group) => group.parentId === id) || [];
    const childrenObject =
      data.objects.filter((group) => group.objectGroupId === id) || [];

    childrenObject.length !== 0 &&
      childrenObject.forEach((object) => {
        objectKeys.push(object.objectKey);
      });

    childrenGroup.length !== 0 &&
      childrenGroup.forEach((group) => {
        // 获取group子项对应的objects子项并保存object_key
        const objects = data.objects.filter(
          (object) => object.objectGroupId === group.objectGroupId
        );
        objects.forEach((object) => {
          objectKeys.push(object.objectKey);
        });

        // 递归获取group的子项
        const childKeys = getAllObjectKeys(group.objectGroupId);
        objectKeys = objectKeys.concat(childKeys);
      });
    const newKeys = objectKeys.filter(
      (item, index, arr) => arr.indexOf(item) === index
    );

    return newKeys;
  };

  const getAllObjectOptions = (id: number) => {
    const newKeys = getAllObjectKeys(id);
    const options: any = [];
    newKeys.forEach((item) => {
      const objectItem =
        data.objects.filter((object) => object.objectKey === item) || [];
      if (objectItem.length !== 0) {
        options.push({
          label: objectItem[0].objectName,
          value: objectItem[0].objectKey,
          disabled: objectItem[0].objectKey === 'memberRemove',
        });
      }
    });
    return options;
  };

  // 全选
  const onCheckAllChangeById = (e: CheckboxChangeEvent, id: number) => {
    const childKeys = getAllObjectKeys(id);
    const newValue = Object.assign([], checkedKeys);
    childKeys.map((item) => {
      if (e.target.checked) {
        if (newValue.indexOf(item) === -1 && item !== 'memberRemove') {
          newValue.push(item);
        }
      } else {
        if (newValue.indexOf(item) !== -1) {
          newValue.splice(newValue.indexOf(item), 1);
        }
      }
      return newValue;
    });
    setCheckedKeys(newValue);
  };

  const onChangeExpand = (e: any, id: number) => {
    if (
      (e.target.className &&
        (e.target.className.indexOf('checkbox-header') !== -1 ||
          e.target.className.indexOf('checkbox-hidden-icon') !== -1)) ||
      disabled
    ) {
      const newValue = Object.assign([], hiddenKeys);
      if (newValue.indexOf(id) !== -1) {
        newValue.splice(newValue.indexOf(id), 1);
      } else {
        newValue.push(id);
      }
      setHiddenKeys(newValue);
    }
  };

  const isNoPermissions = (name: string) => {
    if (props.type && props.type !== RbacRoleType.Custom) {
      return false;
    }
    return name === '工作室管理' || name === '游戏管理';
  };

  const serviceData =
    data.objectGroup.filter((item) => item.objectGroupName === '服务权限') ||
    [];
  const serviceLeftOptions = getDataFromGroup(serviceData[0]?.objectGroupId); // 服务权限的第一级子项
  const selectServiceData =
    data.objectGroup.filter((item) => item.objectGroupId === selectedKey) || [];
  const serviceRightGroupOptions = getDataFromGroup(
    selectServiceData[0]?.objectGroupId
  ); // 服务权限的第二级子项

  serviceLeftOptions.forEach((item) => {
    let itemIndex = 999;
    const menuItem = menus.find((it) => it.name === item.label);
    if (menuItem) {
      itemIndex = menus.indexOf(menuItem) + 1;
    }
    item.sortNum = itemIndex;
  });
  serviceLeftOptions.sort((pre, next) => {
    return pre.sortNum - next.sortNum;
  });

  // 服务权限大类
  const currentGroupObjects = getAllObjectKeys(serviceData[0]?.objectGroupId);
  const serviceCheckAll =
    currentGroupObjects.filter((item) => checkedKeys.indexOf(item) === -1)
      .length === 0;
  const serviceNoCheckAll =
    currentGroupObjects.filter((item) => checkedKeys.indexOf(item) !== -1)
      .length === 0;
  let serviceTips = '';
  if (serviceCheckAll && currentGroupObjects.length !== 0) {
    serviceTips = getFormatMessage('permission_all');
  } else if (currentGroupObjects.length === 0 || serviceNoCheckAll) {
    serviceTips = getFormatMessage('permission_none');
  } else if (!serviceCheckAll && !serviceNoCheckAll) {
    serviceTips = getFormatMessage('permission_part');
  }

  const renderContent = () => {
    return (
      <div className="access-rights-container">
        {/* 非服务权限分类展示 */}
        {data.objectGroup
          .filter(
            (item) => item.parentId === 0 && item.objectGroupName !== '服务权限'
          )
          .map((category) => {
            const options = getAllObjectKeys(category.objectGroupId);
            const objectOptions = getAllObjectOptions(category.objectGroupId);
            let checkAll =
              options.filter((item) => checkedKeys.indexOf(item) === -1)
                .length === 0;
            if (category.objectGroupName === '组织管理') {
              // 组织管理中移除成员被手动禁用
              checkAll =
                options.filter((item) => checkedKeys.indexOf(item) === -1)
                  .length === 1;
            }
            const noCheckAll =
              options.filter((item) => checkedKeys.indexOf(item) !== -1)
                .length === 0;
            let nameTitle = '';
            switch (category.objectGroupName) {
              case '工作室管理':
                nameTitle = getFormatMessage('per_studio');
                break;
              case '组织管理':
                nameTitle = getFormatMessage('per_organization');
                break;
              case '游戏管理':
                nameTitle = getFormatMessage('per_game');
                break;
              case '环境管理':
                nameTitle = getFormatMessage('per_env');
                break;
              case '费用中心':
                nameTitle = getFormatMessage('per_expense');
                break;
              case '审计中心':
                nameTitle = getFormatMessage('per_audit');
                break;
              case 'Client API Control':
                nameTitle = getFormatMessage('per_api');
                break;
              default:
                nameTitle = category.objectGroupName;
            }
            return (
              <div className="group-box">
                <div
                  className="checkbox-header"
                  onClick={(e) => onChangeExpand(e, category.objectGroupId)}
                >
                  <Checkbox
                    onChange={(e) =>
                      onCheckAllChangeById(e, category.objectGroupId)
                    }
                    checked={checkAll && options.length !== 0}
                    indeterminate={!checkAll && !noCheckAll}
                    disabled={
                      options.length === 0 ||
                      isNoPermissions(category.objectGroupName)
                    }
                  >
                    {nameTitle}
                  </Checkbox>
                  <div>
                    {isNoPermissions(category.objectGroupName) ? (
                      <span className="no-per-tips">
                        {getFormatMessage('role_has_no_rights')}
                      </span>
                    ) : (
                      options.length !== 0 && (
                        <img
                          src={menuDown}
                          className={classNames(
                            'checkbox-hidden-icon',
                            hiddenKeys.indexOf(category.objectGroupId) !== -1
                              ? 'show-icon'
                              : ''
                          )}
                        />
                      )
                    )}
                  </div>
                </div>
                {hiddenKeys.indexOf(category.objectGroupId) !== -1 &&
                  !isNoPermissions(category.objectGroupName) &&
                  options.length !== 0 && (
                    <Checkbox.Group
                      options={objectOptions}
                      value={checkedKeys}
                      onChange={(checkedValue) =>
                        onChange(checkedValue, options)
                      }
                      className="checkbox-group"
                    />
                  )}
              </div>
            );
          })}

        {/* 服务权限特殊渲染 */}
        <div className="group-box" style={{ borderBottom: 'none' }}>
          <div
            className="checkbox-header"
            onClick={(e) => onChangeExpand(e, serviceData[0]?.objectGroupId)}
          >
            <Checkbox
              onChange={(e) =>
                onCheckAllChangeById(e, serviceData[0]?.objectGroupId)
              }
              checked={serviceCheckAll && currentGroupObjects.length !== 0}
              indeterminate={!serviceCheckAll && !serviceNoCheckAll}
              disabled={currentGroupObjects.length === 0}
            >
              {getFormatMessage('per_service')}
            </Checkbox>
            <div>
              <img
                src={menuDown}
                className={classNames(
                  'checkbox-hidden-icon',
                  hiddenKeys.indexOf(serviceData[0]?.objectGroupId) !== -1
                    ? 'show-icon'
                    : ''
                )}
              />
            </div>
          </div>
          {hiddenKeys.indexOf(serviceData[0]?.objectGroupId) !== -1 &&
            serviceLeftOptions.length !== 0 && (
              <div className="service-box">
                <div className="service-left-box">
                  {serviceLeftOptions.map((item) => {
                    const optionsData =
                      data.objectGroup.filter(
                        (it) => it.objectGroupId === item.value
                      ) || [];
                    const currentGroupObjects = getAllObjectKeys(
                      optionsData[0]?.objectGroupId
                    );
                    const checkAll =
                      currentGroupObjects.filter(
                        (it) => checkedKeys.indexOf(it) === -1
                      ).length === 0;
                    const noCheckAll =
                      currentGroupObjects.filter(
                        (it) => checkedKeys.indexOf(it) !== -1
                      ).length === 0;
                    return (
                      <div
                        className={classNames(
                          'checkbox-left-item',
                          selectedKey === item.value ? 'left-selected-item' : ''
                        )}
                        onClick={() => setSelectedKey(item.value)}
                      >
                        <div>
                          <Checkbox
                            onChange={(e) =>
                              onCheckAllChangeById(
                                e,
                                selectServiceData[0]?.objectGroupId
                              )
                            }
                            checked={
                              checkAll && currentGroupObjects.length !== 0
                            }
                            indeterminate={!checkAll && !noCheckAll}
                            disabled={currentGroupObjects.length === 0}
                          ></Checkbox>
                          <span>{item.label}</span>
                        </div>
                        <img src={menuDown} className="checkbox-left-icon" />
                      </div>
                    );
                  })}
                </div>
                <div className="checkbox-right-box">
                  {serviceRightGroupOptions.map((item) => {
                    const groupData =
                      data.objectGroup.filter(
                        (group) => group.objectGroupId === item.value
                      ) || [];
                    const serviceRightObjectOptions = getDataFromObjects(
                      groupData[0]?.objectGroupId
                    ); // 服务权限的第三级子项
                    const rightItemCheckNum = serviceRightObjectOptions.filter(
                      (i) => checkedKeys.indexOf(i.value) !== -1
                    ).length;
                    const rightItemCheckAll =
                      serviceRightObjectOptions.filter(
                        (i) => checkedKeys.indexOf(i.value) === -1
                      ).length === 0;
                    const rightItemNoCheckAll = rightItemCheckNum === 0;
                    return (
                      <div className="checkbox-right-item">
                        <Checkbox
                          onChange={(e) =>
                            onCheckAllChangeById(e, groupData[0]?.objectGroupId)
                          }
                          checked={
                            rightItemCheckAll &&
                            serviceRightObjectOptions.length !== 0
                          }
                          indeterminate={
                            !rightItemCheckAll && !rightItemNoCheckAll
                          }
                          disabled={serviceRightObjectOptions.length === 0}
                        >
                          <span style={{ fontSize: '12px' }}>{item.label}</span>
                          <span className="checkbox-right-item-num">{`(${rightItemCheckNum}/${serviceRightObjectOptions.length})`}</span>
                        </Checkbox>
                        {serviceRightObjectOptions.map((it) => {
                          return (
                            <div className="checkbox-right-object-item">
                              <img
                                src={perFour}
                                className="checkbox-right-icon"
                              />
                              <Checkbox
                                onChange={(e) => onObjectChange(e, it.value)}
                                checked={checkedKeys.indexOf(it.value) !== -1}
                              >
                                {it.label}
                              </Checkbox>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
        </div>
      </div>
    );
  };

  const renderViewContent = () => {
    return (
      <div className="access-rights-container">
        {/* 非服务权限分类展示 */}
        {data.objectGroup
          .filter(
            (item) => item.parentId === 0 && item.objectGroupName !== '服务权限'
          )
          .map((category) => {
            const options = getAllObjectKeys(category.objectGroupId);
            const objectOptions = getAllObjectOptions(category.objectGroupId);
            const checkAll =
              options.filter((item) => checkedKeys.indexOf(item) === -1)
                .length === 0;
            const noCheckAll =
              options.filter((item) => checkedKeys.indexOf(item) !== -1)
                .length === 0;
            let tips = '';
            if (checkAll && options.length !== 0) {
              tips = getFormatMessage('permission_all');
            } else if (options.length === 0 || noCheckAll) {
              tips = getFormatMessage('permission_none');
            } else if (!checkAll && !noCheckAll) {
              tips = getFormatMessage('permission_part');
            }
            let nameTitle = '';
            switch (category.objectGroupName) {
              case '工作室管理':
                nameTitle = getFormatMessage('per_studio');
                break;
              case '组织管理':
                nameTitle = getFormatMessage('per_organization');
                break;
              case '游戏管理':
                nameTitle = getFormatMessage('per_game');
                break;
              case '环境管理':
                nameTitle = getFormatMessage('per_env');
                break;
              case '费用中心':
                nameTitle = getFormatMessage('per_expense');
                break;
              case '审计中心':
                nameTitle = getFormatMessage('per_audit');
                break;
              case 'Client API Control':
                nameTitle = getFormatMessage('per_api');
                break;
              default:
                nameTitle = category.objectGroupName;
            }
            return (
              <div className="group-box">
                <div
                  className="checkbox-header"
                  onClick={(e) => onChangeExpand(e, category.objectGroupId)}
                >
                  <div className="checkbox-header-left">
                    <img
                      src={
                        isNoPermissions(category.objectGroupName) ||
                        options.length === 0 ||
                        noCheckAll
                          ? accessOneFalse
                          : accessOneTrue
                      }
                      className="checkbox-header-left-icon"
                    />
                    <span
                      style={{
                        color:
                          isNoPermissions(category.objectGroupName) ||
                          options.length === 0 ||
                          noCheckAll
                            ? '#86909C'
                            : '#1D2129',
                      }}
                    >
                      {nameTitle}
                    </span>
                  </div>
                  <div>
                    {isNoPermissions(category.objectGroupName) ? (
                      <span className="no-per-tips">
                        {getFormatMessage('role_has_no_rights')}
                      </span>
                    ) : (
                      options.length !== 0 && (
                        <div className="checkbox-header-right">
                          <span>{tips}</span>
                          <img
                            src={menuDown}
                            className={classNames(
                              'checkbox-hidden-icon',
                              hiddenKeys.indexOf(category.objectGroupId) !== -1
                                ? 'show-icon'
                                : ''
                            )}
                          />
                        </div>
                      )
                    )}
                  </div>
                </div>
                {hiddenKeys.indexOf(category.objectGroupId) !== -1 &&
                  !isNoPermissions(category.objectGroupName) &&
                  options.length !== 0 && (
                    <div className="checkbox-group">
                      {objectOptions.map((item: any) => {
                        return (
                          <div className="checkbox-group-item">
                            <img
                              src={
                                checkedKeys.indexOf(item.value) !== -1
                                  ? accessTwoTrue
                                  : accessTwoFalse
                              }
                              className="checkbox-group-item-icon"
                            />
                            <span
                              style={{
                                color:
                                  checkedKeys.indexOf(item.value) !== -1
                                    ? '#1D2129'
                                    : '#86909C',
                              }}
                            >
                              {item.label}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>
            );
          })}

        {/* 服务权限特殊渲染 */}
        <div className="group-box" style={{ borderBottom: 'none' }}>
          <div
            className="checkbox-header"
            onClick={(e) => onChangeExpand(e, serviceData[0]?.objectGroupId)}
          >
            <div className="checkbox-header-left">
              <img
                src={
                  isNoPermissions(serviceData[0]?.objectGroupName) ||
                  currentGroupObjects.length === 0 ||
                  serviceNoCheckAll
                    ? accessOneFalse
                    : accessOneTrue
                }
                className="checkbox-header-left-icon"
              />
              <span
                style={{
                  color:
                    isNoPermissions(serviceData[0]?.objectGroupName) ||
                    currentGroupObjects.length === 0 ||
                    serviceNoCheckAll
                      ? '#86909C'
                      : '#1D2129',
                }}
              >
                {getFormatMessage('per_service')}
              </span>
            </div>
            <div className="checkbox-header-right">
              <span>{serviceTips}</span>
              <img
                src={menuDown}
                className={classNames(
                  'checkbox-hidden-icon',
                  hiddenKeys.indexOf(serviceData[0]?.objectGroupId) !== -1
                    ? 'show-icon'
                    : ''
                )}
              />
            </div>
          </div>
          {hiddenKeys.indexOf(serviceData[0]?.objectGroupId) !== -1 &&
            serviceLeftOptions.length !== 0 && (
              <div className="service-box">
                <div className="service-left-box">
                  {serviceLeftOptions.map((item) => {
                    const optionsData =
                      data.objectGroup.filter(
                        (it) => it.objectGroupId === item.value
                      ) || [];
                    const currentGroupObjects = getAllObjectKeys(
                      optionsData[0]?.objectGroupId
                    );
                    const noCheckAll =
                      currentGroupObjects.filter(
                        (it) => checkedKeys.indexOf(it) !== -1
                      ).length === 0;
                    return (
                      <div
                        className={classNames(
                          'checkbox-left-item',
                          selectedKey === item.value ? 'left-selected-item' : ''
                        )}
                        onClick={() => setSelectedKey(item.value)}
                      >
                        <div className="checkbox-left-item-box">
                          <img
                            src={
                              currentGroupObjects.length === 0 || noCheckAll
                                ? accessTwoFalse
                                : accessTwoTrue
                            }
                          />
                          <span
                            style={{
                              color:
                                currentGroupObjects.length === 0 || noCheckAll
                                  ? '#86909C'
                                  : '#1D2129',
                            }}
                          >
                            {item.label}
                          </span>
                        </div>
                        <img src={menuDown} className="checkbox-left-icon" />
                      </div>
                    );
                  })}
                </div>
                <div className="checkbox-right-box">
                  {serviceRightGroupOptions.map((item) => {
                    const groupData =
                      data.objectGroup.filter(
                        (group) => group.objectGroupId === item.value
                      ) || [];
                    const serviceRightObjectOptions = getDataFromObjects(
                      groupData[0]?.objectGroupId
                    ); // 服务权限的第三级子项
                    const rightItemCheckNum = serviceRightObjectOptions.filter(
                      (i) => checkedKeys.indexOf(i.value) !== -1
                    ).length;
                    const rightItemNoCheckAll = rightItemCheckNum === 0;
                    return (
                      <div className="checkbox-right-item">
                        <div className="checkbox-right-item-group">
                          <img
                            src={
                              serviceRightObjectOptions.length === 0 ||
                              rightItemNoCheckAll
                                ? accessTwoFalse
                                : accessTwoTrue
                            }
                          />
                          <span
                            style={{
                              color:
                                serviceRightObjectOptions.length === 0 ||
                                rightItemNoCheckAll
                                  ? '#86909C'
                                  : '#1D2129',
                            }}
                          >
                            {item.label}
                          </span>
                          <span className="checkbox-right-item-num">{`(${rightItemCheckNum}/${serviceRightObjectOptions.length})`}</span>
                        </div>
                        {serviceRightObjectOptions.map((it) => {
                          return (
                            <div className="checkbox-right-object-item">
                              <img
                                src={perFour}
                                className="checkbox-right-icon"
                              />
                              <div className="checkbox-right-object">
                                <img
                                  src={
                                    checkedKeys.indexOf(it.value) === -1
                                      ? accessTwoFalse
                                      : accessTwoTrue
                                  }
                                />
                                <span
                                  style={{
                                    color:
                                      checkedKeys.indexOf(it.value) === -1
                                        ? '#86909C'
                                        : '#1D2129',
                                  }}
                                >
                                  {it.label}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
        </div>
      </div>
    );
  };

  return disabled ? renderViewContent() : renderContent();
};
